import { render, staticRenderFns } from "./Toggle2fa.vue?vue&type=template&id=c0da3cfa"
import script from "./Toggle2fa.vue?vue&type=script&lang=js"
export * from "./Toggle2fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports